import ActionTypes from "../constants/ActionTypes";
import BASE_URL from "../constants/Api";
import axiosInstance from "../helpers/refreshTokenMiddleware";

/* =========================================================
 * 管理者詳細取得 (Admin Detail Fetch)
 * ========================================================= */
export const fetchAdminDetailRequest = () => ({
  type: ActionTypes.FETCH_ADMIN_DETAIL_REQUEST,
});

export const fetchAdminDetailSuccess = (detail) => ({
  type: ActionTypes.FETCH_ADMIN_DETAIL_SUCCESS,
  payload: detail,
});

export const fetchAdminDetailFailure = (error) => ({
  type: ActionTypes.FETCH_ADMIN_DETAIL_FAILURE,
  payload: error,
  error: true,
});

/**
 * 管理者 詳細データ取得 API
 * GET ?path=admin&type=get-data&id=xx
 */
export const fetchAdminDetail = (adminId) => async (dispatch) => {
  dispatch(fetchAdminDetailRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const response = await axiosInstance.get(
      `${BASE_URL}?path=admin&type=get-data&id=${adminId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const detail = response.data.respons;

    dispatch(fetchAdminDetailSuccess(detail));

    return { payload: detail };
  } catch (error) {
    dispatch(fetchAdminDetailFailure(error.message));
    return { error: error.message };
  }
};

/* =========================================================
 * 管理者編集 (Admin Update)
 * ========================================================= */
export const fetchAdminUpdateRequest = () => ({
  type: ActionTypes.FETCH_ADMIN_UPDATE_REQUEST,
});

export const fetchAdminUpdateSuccess = (data) => ({
  type: ActionTypes.FETCH_ADMIN_UPDATE_SUCCESS,
  payload: data,
});

export const fetchAdminUpdateFailure = (data) => ({
  type: ActionTypes.FETCH_ADMIN_UPDATE_FAILURE,
  payload: data,
});

export const updateAdmin = (payload) => async (dispatch) => {
  dispatch(fetchAdminUpdateRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const response = await axiosInstance.post(
      `${BASE_URL}?path=admin&type=update-info-data`,
      payload,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );

    if (response.data.status !== 200) {
      throw new Error(response.data.respons || "更新に失敗しました。");
    }

    // SUCCESS
    dispatch(fetchAdminUpdateSuccess(response.data.respons));
    return { payload: response.data.respons };

  } catch (error) {
    // FAIL
    const errorMsg = error.response?.data?.respons || error.message;
    dispatch(fetchAdminUpdateFailure(errorMsg));
    return { error: errorMsg };
  }
};


/* =========================================================
 * 管理者削除 (Admin Delete)
 * ========================================================= */
export const fetchAdminDeleteRequest = () => ({
  type: ActionTypes.FETCH_ADMIN_DELETE_REQUEST,
});

export const fetchAdminDeleteSuccess = (response) => ({
  type: ActionTypes.FETCH_ADMIN_DELETE_SUCCESS,
  payload: response,
});

export const fetchAdminDeleteFailure = (error) => ({
  type: ActionTypes.FETCH_ADMIN_DELETE_FAILURE,
  payload: error,
  error: true,
});

export const deleteAdmin = (adminId) => async (dispatch) => {
  dispatch(fetchAdminDeleteRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const body = { admin_id: adminId };

    const response = await axiosInstance.post(
      `${BASE_URL}?path=admin&type=delete-data`,
      body,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );

    if (response.data.status !== 200) {
      throw new Error(response.data.respons || "削除に失敗しました。");
    }

    dispatch(fetchAdminDeleteSuccess(response.data.respons));
    return { payload: response.data.respons };

  } catch (error) {
    const errorMsg = error.response?.data?.respons || error.message;
    dispatch(fetchAdminDeleteFailure(errorMsg));
    return { error: errorMsg };
  }
};

/* =========================================================
 * パスワード更新 (Admin Password Update)
 * ========================================================= */
export const fetchAdminPasswordUpdateRequest = () => ({
  type: ActionTypes.UPDATE_PASSWORD_REQUEST,
});

export const fetchAdminPasswordUpdateSuccess = (data) => ({
  type: ActionTypes.UPDATE_PASSWORD_SUCCESS,
  payload: data,
});

export const fetchAdminPasswordUpdateFailure = (error) => ({
  type: ActionTypes.UPDATE_PASSWORD_FAILURE,
  payload: error,
  error: true,
});

/**
 * 管理者 パスワード変更 API  
 * 同じAPIを2回使用：
 * 1回目 → password_old / password_new
 * 2回目 → + session_id + otp
 */
export const updateAdminPassword = (body) => async (dispatch) => {
  dispatch(fetchAdminPasswordUpdateRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const response = await axiosInstance.post(
      `${BASE_URL}?path=admin&type=update-password`,
      body,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );

    const data = response.data.respons;
    const status = response.data.status

    if (data?.otp_enable === 1 && data?.session_id) {
      dispatch(fetchAdminPasswordUpdateSuccess({
        otp_enable: 1,
        session_id: data.session_id,
      }));

      return { payload: data }; 
    }

    if (status !== 200) {
      dispatch(fetchAdminPasswordUpdateFailure(data));
      return { error: data }; 
    }

    if (data?.success === 1) {
      dispatch(fetchAdminPasswordUpdateSuccess(data));
      return { payload: data };
    }

    dispatch(fetchAdminPasswordUpdateFailure(data));
    return { error: data };

  } catch (error) {
    const errorMsg = error.response?.data?.respons || error.message;
    dispatch(fetchAdminPasswordUpdateFailure(errorMsg));
    return { error: errorMsg };
  }
};
